import React, { useState, useEffect } from "react";
import Select from "react-select";

const MultiSelectFilter = ({ onFilter, column, options = [] }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    // ✅ Keep original casing for backend match
    const selectedValues = selectedOptions.map((opt) => opt.value.toString());
    onFilter(selectedValues); // ✅ Direct call, no toLowerCase()


    console.log(`Applying filter for ${column?.text}:`, selectedValues);

    onFilter(selectedValues);
  }, [selectedOptions]);

  return (
    <Select
      options={options}
      isMulti
      isSearchable
      placeholder={`Search and select ${column?.text || "Options"}...`}
      value={selectedOptions}
      onChange={(options) => setSelectedOptions(options || [])}
      isClearable
    />
  );
};

export default MultiSelectFilter;
